// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Default_default-container__rSjwc {
  display: grid;
  grid-template-columns: 1fr;
  position: relative;
  width: 100%;
  height: 100%;
  background-color: var(--m-background-color);
}
.Default_default-container__rSjwc .Default_default-sidebar__35PqP {
  display: none;
  background-color: #fff;
  width: 280px;
  max-width: 86vw;
  z-index: 50;
  bottom: 0;
  position: fixed;
  top: 0;
  left: 0;
  transform: translateX(-100%);
  transition: transform 0.25s ease-in-out;
  box-shadow: var(--m-header-box-shadow);
  border-right: 1px solid var(--m-default-border-color);
}
.Default_default-container__rSjwc .Default_default-sidebar--open__IpBVK {
  transform: translateX(0);
}
.Default_default-container__rSjwc .Default_default-main__rOfgx {
  margin-left: 0;
  overflow: auto;
  width: 100vw;
  height: 100vh;
  max-width: 100vw;
  transition: ease-in-out 0.4s;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow-x: hidden;
  position: relative;
  overflow-y: auto;
}
.Default_default-container__rSjwc .Default_default-main__rOfgx.Default_mobile-main__srSwk {
  margin-left: 70px;
  width: calc(100vw - 80px);
  max-width: calc(100vw - 70px);
}
.Default_default-container__rSjwc .Default_overlay-container__AnXvg {
  background-color: rgba(19, 33, 68, 0.25);
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
  z-index: 40;
  padding: 0;
  border: 0;
}
.Default_default-container__rSjwc .Default_sidebar-sm-md__ch4RJ {
  background-color: var(--m-sidebar-background-color);
  width: 250px;
  z-index: 50;
}

@media (max-width: 480px) {
  .Default_default-container__rSjwc {
    grid-template-columns: 0px 4fr;
    position: relative;
  }
  .Default_default-container__rSjwc .Default_default-sidebar__35PqP {
    width: 0px;
    max-width: 0px;
  }
  .Default_default-container__rSjwc .Default_default-main__rOfgx {
    margin-left: 0px;
    width: 100vw;
    height: 100vh;
    max-width: 100vw;
  }
}
@media (min-width: 481px) and (max-width: 768px) {
  .Default_default-container__rSjwc {
    grid-template-columns: 0px 8fr;
    position: relative;
  }
  .Default_default-container__rSjwc .Default_default-sidebar__35PqP {
    width: 0px;
    max-width: 0px;
  }
  .Default_default-container__rSjwc .Default_default-main__rOfgx {
    margin-left: 0px;
    width: 100vw;
    height: 100vh;
    max-width: 100vw;
  }
}
@media (min-width: 769px) and (max-width: 991px) {
  .Default_default-container__rSjwc {
    grid-template-columns: 0px 12fr;
  }
  .Default_default-container__rSjwc .Default_default-sidebar__35PqP {
    width: 0px;
    max-width: 0px;
  }
  .Default_default-container__rSjwc .Default_default-main__rOfgx {
    margin-left: 0px;
    width: 100vw;
    height: 100vh;
    max-width: 100vw;
  }
}
@media (max-width: 1199.88px) {
  .Default_default-container__rSjwc .Default_default-sidebar__35PqP {
    display: block;
    width: 280px;
    max-width: 86vw;
  }
}`, "",{"version":3,"sources":["webpack://./src/layout/Default/Default.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,0BAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,2CAAA;AACF;AACE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,4BAAA;EACA,uCAAA;EACA,sCAAA;EACA,qDAAA;AACJ;AACI;EACE,wBAAA;AACN;AAGE;EACE,cAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,4BAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AADJ;AAGI;EACE,iBAAA;EACA,yBAAA;EACA,6BAAA;AADN;AAKE;EACE,wCAAA;EACA,eAAA;EACA,QAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;AAHJ;AAME;EACE,mDAAA;EACA,YAAA;EACA,WAAA;AAJJ;;AAQA;EACE;IACE,8BAAA;IACA,kBAAA;EALF;EAOE;IACE,UAAA;IACA,cAAA;EALJ;EAQE;IACE,gBAAA;IACA,YAAA;IACA,aAAA;IACA,gBAAA;EANJ;AACF;AAUA;EACE;IACE,8BAAA;IACA,kBAAA;EARF;EAUE;IACE,UAAA;IACA,cAAA;EARJ;EAWE;IACE,gBAAA;IACA,YAAA;IACA,aAAA;IACA,gBAAA;EATJ;AACF;AAaA;EACE;IACE,+BAAA;EAXF;EAaE;IACE,UAAA;IACA,cAAA;EAXJ;EAcE;IACE,gBAAA;IACA,YAAA;IACA,aAAA;IACA,gBAAA;EAZJ;AACF;AAgBA;EAEI;IACE,cAAA;IACA,YAAA;IACA,eAAA;EAfJ;AACF","sourcesContent":[".default-container {\n  display: grid;\n  grid-template-columns: 1fr;\n  position: relative;\n  width: 100%;\n  height: 100%;\n  background-color: var(--m-background-color);\n\n  .default-sidebar {\n    display: none;\n    background-color: #fff;\n    width: 280px;\n    max-width: 86vw;\n    z-index: 50;\n    bottom: 0;\n    position: fixed;\n    top: 0;\n    left: 0;\n    transform: translateX(-100%);\n    transition: transform 0.25s ease-in-out;\n    box-shadow: var(--m-header-box-shadow);\n    border-right: 1px solid var(--m-default-border-color);\n\n    &--open {\n      transform: translateX(0);\n    }\n  }\n\n  .default-main {\n    margin-left: 0;\n    overflow: auto;\n    width: 100vw;\n    height: 100vh;\n    max-width: 100vw;\n    transition: ease-in-out 0.4s;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    overflow-x: hidden;\n    position: relative;\n    overflow-y: auto;\n\n    &.mobile-main {\n      margin-left: 70px;\n      width: calc(100vw - 80px);\n      max-width: calc(100vw - 70px);\n    }\n  }\n\n  .overlay-container {\n    background-color: rgba(19, 33, 68, 0.25);\n    position: fixed;\n    inset: 0;\n    width: 100vw;\n    height: 100vh;\n    z-index: 40;\n    padding: 0;\n    border: 0;\n  }\n\n  .sidebar-sm-md {\n    background-color: var(--m-sidebar-background-color);\n    width: 250px;\n    z-index: 50;\n  }\n}\n\n@media (max-width: 480px) {\n  .default-container {\n    grid-template-columns: 0px 4fr;\n    position: relative;\n\n    .default-sidebar {\n      width: 0px;\n      max-width: 0px;\n    }\n\n    .default-main {\n      margin-left: 0px;\n      width: 100vw;\n      height: 100vh;\n      max-width: 100vw;\n    }\n  }\n}\n\n@media (min-width: 481px) and (max-width: 768px) {\n  .default-container {\n    grid-template-columns: 0px 8fr;\n    position: relative;\n\n    .default-sidebar {\n      width: 0px;\n      max-width: 0px;\n    }\n\n    .default-main {\n      margin-left: 0px;\n      width: 100vw;\n      height: 100vh;\n      max-width: 100vw;\n    }\n  }\n}\n\n@media (min-width: 769px) and (max-width: 991px) {\n  .default-container {\n    grid-template-columns: 0px 12fr;\n\n    .default-sidebar {\n      width: 0px;\n      max-width: 0px;\n    }\n\n    .default-main {\n      margin-left: 0px;\n      width: 100vw;\n      height: 100vh;\n      max-width: 100vw;\n    }\n  }\n}\n\n@media (max-width: 1199.88px) {\n  .default-container {\n    .default-sidebar {\n      display: block;\n      width: 280px;\n      max-width: 86vw;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"default-container": `Default_default-container__rSjwc`,
	"default-sidebar": `Default_default-sidebar__35PqP`,
	"default-sidebar--open": `Default_default-sidebar--open__IpBVK`,
	"default-main": `Default_default-main__rOfgx`,
	"mobile-main": `Default_mobile-main__srSwk`,
	"overlay-container": `Default_overlay-container__AnXvg`,
	"sidebar-sm-md": `Default_sidebar-sm-md__ch4RJ`
};
export default ___CSS_LOADER_EXPORT___;
